import { render, staticRenderFns } from "./ModalFotosAluno.vue?vue&type=template&id=61439fbd"
import script from "./ModalFotosAluno.vue?vue&type=script&lang=js"
export * from "./ModalFotosAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports